export default __webpack_public_path__ + "83ca004833f17376299855b0304fcc29.svg";